module.exports = __webpack_public_path__ + "img/videowiki.490cabf9.svg";